export default "__VITE_ASSET__0cC4LDU9__"